module.exports = __webpack_public_path__ + "img/google.f2f36c2e.svg";